const tree = [
  {
    name: "root",
    display: "All",
    children: [
      {
        name: "優惠專區",
        display: "優惠專區",
        children: []
      },
      {
        name: "產地",
        display: "產地",
        children: [
          {
            name: "產地-中美洲及加勒比海地區",
            display: "中美洲及加勒比海地區",
            children: [
              {
                name: "產地-中美洲及加勒比海地區-巴拿馬",
                display: "巴拿馬",
                children: []
              },
              {
                name: "產地-中美洲及加勒比海地區-哥斯大黎加",
                display: "哥斯大黎加",
                children: []
              },
              {
                name: "產地-中美洲及加勒比海地區-瓜地馬拉",
                display: "瓜地馬拉",
                children: []
              },
              {
                name: "產地-中美洲及加勒比海地區-尼加拉瓜",
                display: "尼加拉瓜",
                children: []
              },
              {
                name: "產地-中美洲及加勒比海地區-薩爾瓦多",
                display: "薩爾瓦多",
                children: []
              },
              {
                name: "產地-中美洲及加勒比海地區-古巴",
                display: "古巴",
                children: []
              }
            ]
          },
          {
            name: "產地-南美洲",
            display: "南美洲",
            children: [
              {
                name: "產地-南美洲-哥倫比亞",
                display: "哥倫比亞",
                children: []
              },
              {
                name: "產地-南美洲-巴西",
                display: "巴西",
                children: []
              }
            ]
          },
          {
            name: "產地-非洲",
            display: "非洲",
            children: [
              {
                name: "產地-非洲-衣索比亞",
                display: "衣索比亞",
                children: []
              },
              {
                name: "產地-非洲-肯亞",
                display: "肯亞",
                children: []
              },
              {
                name: "產地-非洲-坦尚尼亞",
                display: "坦尚尼亞",
                children: []
              }
            ]
          },
          {
            name: "產地-亞洲",
            display: "亞洲",
            children: [
              {
                name: "產地-亞洲-台灣",
                display: "台灣",
                children: []
              },
              {
                name: "產地-亞洲-印尼",
                display: "印尼",
                children: []
              },
              {
                name: "產地-亞洲-爪哇",
                display: "爪哇",
                children: []
              },
              {
                name: "產地-亞洲-蘇門答臘",
                display: "蘇門答臘",
                children: []
              },
              {
                name: "產地-亞洲-蘇拉維西",
                display: "蘇拉維西",
                children: []
              }
            ]
          }
        ]
      },
      {
        name: "處理法",
        display: "處理法",
        children: [
          {
            name: "處理法-日曬",
            display: "日曬",
            children: []
          },
          {
            name: "處理法-水洗",
            display: "水洗",
            children: []
          },
          {
            name: "處理法-蜜處理",
            display: "蜜處理",
            children: []
          },
          {
            name: "處理法-特殊處理法",
            display: "特殊處理法",
            children: []
          }
        ]
      },
      {
        name: "焙度",
        display: "焙度",
        children: [
          {
            name: "焙度-淺焙",
            display: "淺焙",
            children: []
          },
          {
            name: "焙度-中焙",
            display: "中焙",
            children: []
          },
          {
            name: "焙度-深焙",
            display: "深焙",
            children: []
          }
        ]
      },
      {
        name: "香氣",
        display: "香氣",
        children: [
          {
            name: "香氣-果香",
            display: "果香",
            children: []
          },
          {
            name: "香氣-土地芬芳",
            display: "土地芬芳",
            children: []
          },
          {
            name: "香氣-煙熏",
            display: "煙熏",
            children: []
          },
          {
            name: "香氣-花香",
            display: "花香",
            children: []
          },
          {
            name: "香氣-莓果",
            display: "莓果",
            children: []
          },
          {
            name: "香氣-堅果",
            display: "堅果",
            children: []
          },
          {
            name: "香氣-酒香",
            display: "酒香",
            children: []
          }
        ]
      },
      {
        name: "商品類別",
        display: "商品類別",
        children: [
          {
            name: "商品類別-生豆",
            display: "生豆",
            children: []
          },
          {
            name: "商品類別-咖啡豆",
            display: "咖啡豆",
            children: []
          },
          {
            name: "商品類別-濾掛盒",
            display: "濾掛盒",
            children: []
          },
          {
            name: "商品類別-單包濾掛",
            display: "單包濾掛",
            children: []
          },
          {
            name: "商品類別-咖啡濾紙",
            display: "咖啡濾紙",
            children: []
          },
          {
            name: "商品類別-咖啡禮盒",
            display: "咖啡禮盒",
            children: []
          },
          {
            name: "商品類別-沖煮設備",
            display: "沖煮設備",
            children: []
          },
          {
            name: "商品類別-濾杯器皿",
            display: "濾杯器皿",
            children: []
          },
          {
            name: "商品類別-Hario",
            display: "Hario",
            children: []
          },
          {
            name: "商品類別-Oceanrich",
            display: "Oceanrich",
            children: []
          }
        ]
      }
    ]
  }
];

module.exports = tree;
exports.default = tree;
